import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
 * react-slick Wrapper Component
 * https://github.com/akiran/react-slick
 * js(移行前): src/container/Ui/Slider/index.js
 */
import clsx from 'clsx';
import { Fragment, createElement, useMemo, useEffect, useRef, useState, } from 'react';
import ReactSlider from 'react-slick';
import { NextButton } from '@/components/ui/Slider/SliderBase/Button/NextButton';
import { PrevButton } from '@/components/ui/Slider/SliderBase/Button/PrevButton';
import { IS_MODE_REGRESSION } from '@/define/env';
export const SliderBase = (props) => {
    const { children, className = '', customNextButton = undefined, customNextButtonProps = {}, customPrevButton = undefined, customPrevButtonProps = {}, fillCount = undefined, setSliderRef = null, setting, wrapperClassName = '', wrapperElement = null, } = props;
    const fillArray = useMemo(() => Object.keys(Array(fillCount || 0).fill('')), [fillCount]);
    const sliderRef = useRef();
    const [hasSetPosition, setHasSetPosition] = useState(false);
    // https://github.com/akiran/react-slick/issues/1946#issuecomment-768935762
    useEffect(() => {
        if (sliderRef.current && setting.initialSlide && !hasSetPosition) {
            sliderRef.current.slickGoTo(setting.initialSlide);
            setHasSetPosition(true);
        }
    }, [setting.initialSlide, hasSetPosition, sliderRef]);
    const Wrapper = wrapperElement || Fragment;
    const setProps = {};
    if (wrapperElement) {
        setProps.className = wrapperClassName;
    }
    return (_jsx(Wrapper, Object.assign({}, setProps, { children: _jsxs(ReactSlider, Object.assign({}, setting, { 
            // 画像回帰テスト時は自動再生を無効化
            autoplay: IS_MODE_REGRESSION ? false : setting.autoplay, className: clsx('[&_.slick-track]:!flex', className), nextArrow: customNextButton ? (createElement(customNextButton, customNextButtonProps)) : (_jsx(NextButton, Object.assign({}, customNextButtonProps))), prevArrow: customPrevButton ? (createElement(customPrevButton, customPrevButtonProps)) : (_jsx(PrevButton, Object.assign({}, customPrevButtonProps))), ref: (slide) => {
                sliderRef.current = slide;
                if (setSliderRef) {
                    setSliderRef(slide);
                }
            } }, { children: [children, fillArray.map((v) => (_jsx("div", { className: 'is-dnone' }, v)))] })) })));
};
